import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { NTManualAllocation } from './nt-manual-allocation';
import { DataParam, customfunctions } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';

declare var $;

@Component({
  selector: 'app-nt-manual-allocation',
  templateUrl: './nt-manual-allocation.component.html',
  styleUrls: ['./nt-manual-allocation.component.css']
})
/** Vendor-ManualAllocation component*/
export class NTManualAllocationComponent implements OnInit {
  modelItem = new NTManualAllocation();

  showModal: boolean;
  dataSet: string;
  dataTable: any;
  @ViewChild('dataTable') table;
  public lstBatchList: any = null;
  public lArticleList: any;
  public userList: any;
  //dataSetAL: string;
  //dataTableAL: any;
  //@ViewChild('dataAllocatedTable') tableAL;

  fileBase64: any;
  file: any;

  VendorEmailList: any;
  itemVendorL: any;

  /** Vendor Allocation ctor */
  constructor(private router: Router, private route: ActivatedRoute) {

    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <NTManualAllocation>data["NTManualAllocationPage"];

        $("#ddluser").select2({
          placeholder: "Select User", dropdownParent: "#divSelect"
        });

        $("#lstBatch").select2({
          placeholder: "Select Batch(s)", dropdownParent: "#divMainFilter"
        }); $("#lstBatch").val([]).trigger("change");
        $("#lstArticle").select2({
          placeholder: "Select Article(s)", dropdownParent: "#divMainFilter"
        }); $("#lstArticle").val([]).trigger("change");
        this.getFiltered();
        customfunctions.SetDateValuesRangebased("#Txt_FromDate", "#Txt_ToDate", "Weekly", 0, 0);
        customfunctions.SetTodayDateValues('#TxtAllocateDate');
      },
      error => {
        ngswal("Warning !", error.message, "warning");
      });


  }

  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }

  // LoadManualAllocationList:dropdownlist
  GetManualAllocationList(tabName = 'Conversion') {
    $("#LoadingImage").show();
    let _filterType = $('#ddlFilterType').val();
    if (tabName != 'Conversion') {
      if (_filterType == 'All') {
        _filterType = tabName;
      }
      else {
        _filterType = `${tabName}${_filterType}`;
      }
    }
    var articleData = {
      BatchList: $("#lstBatch").val() == null ? '' : $("#lstBatch").val().toString(),
      ArticleList: $("#lstArticle").val() == null ? '' : $("#lstArticle").val().toString(),
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val(),
      FilterType: _filterType
    };
    ApiMethod.postMethod(this.modelItem.GetNTManualAPI, articleData).subscribe(
      result => {

        this.dataSet = JSON.stringify(result.aAllocateArticleList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);
        //Dynamic datable
        let aColList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.aNewButtonName = 'btnMultipleAllocate';
        dataItem.aNewButtonToolTip = 'Allocate';
        dataItem.aNewButtonName1 = 'btnMultipleSendtoVendorConfirm';
        dataItem.aNewButtonToolTip1 = 'Send to Vendor';
        dataItem.aNewButtonName2 = 'btnMultipleExcel';
        dataItem.aNewButtonToolTip2 = 'Load Excel';
        dataItem.aNewButtonName3 = 'btnAutoNTAllocation';
        dataItem.aNewButtonToolTip3 = 'Auto Allocate to User';
        dataItem.colsetting = false;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 250);
        dataItem.modulename = 'VendorAllocation';
        dataItem.infoPopupID = 'ID';
        dataItem.StateSave = false;
        dataItem.defaultPagesize = -1;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        if (this.lstBatchList == null) {
          this.lstBatchList = GlobalConstants.distinctBy('Volume', result.aAllocateArticleList);
        }
        this.lArticleList = result.aAllocateArticleList;

        //Dynamic datable
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }
  getArticleByBatch() {
    var articleData = {
      BatchList: $("#lstBatch").val() == null ? '' : $("#lstBatch").val().toString(),
      ArticleList: $("#lstArticle").val() == null ? '' : $("#lstArticle").val().toString(),
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      FromDate: $('#Txt_FromDate').val(),
      ToDate: $('#Txt_ToDate').val(),
      FilterType: $('#ddlFilterType').val()
    };

    ApiMethod.postMethod(this.modelItem.GetArticleListByBatchAPI, articleData).subscribe(
      result => {
        this.lArticleList = result.volumeList;

        $("#lstIssue").val(-1).trigger("change");
        $("#lstVolume").val(-1).trigger("change");

      }, error => {
        $("#LoadingImage").hide();
      });
  }
  getFiltered() {
    let _tabName = $('.nav-link.active')[0].name;
    this.GetManualAllocationList(_tabName);
  }
  resetFilter() {
    this.getFiltered();
  }
  AllocateMultiple() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    $("#LoadingImagePopup").show();
    var dataParam = {
      PublisherID: localStorage.aPubID,
      ArticleIDList: localStorage.selectRowIdVal,
      AllocatedVID: $('#ddluser').val(),
      AllocateDate: $('#TxtAllocateDate').val(),
      AllocationProcess: $('.nav-link.active')[0].name,
      UpdatedBy: localStorage.aLoginID
    }
    ApiMethod.postMethod(this.modelItem.AllocatetoUser, dataParam).subscribe(
      result => {
        if (result.status) {
          this.getFiltered();
          ngswal("Success !", result.message, "success");
          this.showModal = true;
        } else {
          ngswal("Failed !...", result.message, "warning");
        }

        $("#LoadingImagePopup").hide();
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  allocateVendorConfirmation() {
    if (localStorage.dropId == "" || localStorage.dropId == "Select") {
      ngswal("Warning", "Please select User !", "warning");
      return;
    }
    ngswal({
      title: "Confirmation",
      text: "Do you want to Allocate ?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnAllocateConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });

  }

  // Allocate Article for vendor
  allocateVendor() {
    if (localStorage.dropId == "" || localStorage.dropId == "Select") {
      ngswal("Warning", "Please select User !", "warning");
      return;
    }
    else {

      let _allocateDate = new Date();
      const storedDate = localStorage.getItem('datepickerId');

      if (storedDate) {
        _allocateDate = new Date(storedDate);
      }
      ngswal({
        title: 'Please wait processing!.....',
        text: '',
        showCancelButton: false,
        showConfirmButton: false
      });
      $("#LoadingImage").show();
      var dataParam = {
        PublisherID: localStorage.aPubID,
        ArticleIDList: localStorage.aEID,
        AllocatedVID: localStorage.dropId,
        AllocateDate: _allocateDate,
        AllocationProcess: $('.nav-link.active')[0].name,
        UpdatedBy: localStorage.aLoginID
      }
      ApiMethod.postMethod(this.modelItem.AllocatetoUser, dataParam).subscribe(
        result => {

          if (result.status) {
            ngswal("Success !", result.message, "success");
          } else {
            ngswal("Failed !...", result.message, "warning");
          }
          this.getFiltered();
          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        }
      );
    }
  }

  allocateSelecteArticle() {
    if (localStorage.selectRowIdVal == "") {
      ngswal("Warning", "Please select article !", "warning");
      return;
    }

    ApiMethod.getMethod(this.modelItem.GetUserList + "/" + localStorage.aPubID).subscribe(
      result => {
        this.userList = result.aUserListL


      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );

    this.showModal = true;
    $("#ddluser").val(-1).trigger("change");
    this.dropdownlistValue();
  }

  hide() {
    this.showModal = false;
  }

  dropdownlistValue() {
    $('#txtCapacity').val('0').prop('disabled', true);
    //selectedRow.find('#Capacity').val(VendorEmailList[0].ArticleCount);
    $('#txtAllocated').prop('disabled', true).val(0);
    $('#txtUnAllocated').prop('disabled', true).val(0);
    $('#txtAvailable').prop('disabled', true).val('');

    if ($('#ddluser').val() != null && $('#ddluser').val() != 0) {

      ApiMethod.getMethod(this.modelItem.GetNTCapcityList + "/" + localStorage.aPubID + "/" + $('#ddluser').val()).subscribe(
        result => {
          var VendorEmailList = result.acolCapacityL

          $('#txtCapacity').val(VendorEmailList[0].ArticleCount).prop('disabled', true);
          //selectedRow.find('#Capacity').val(VendorEmailList[0].ArticleCount);
          $('#txtAllocated').prop('disabled', true).val(VendorEmailList[0].Allotted);
          $('#txtUnAllocated').prop('disabled', true).val(VendorEmailList[0].UnAllocated);
          $('#txtAvailable').prop('disabled', true).val(VendorEmailList[0].Available);


        }, error => {
          $("#LoadingImage").hide();
          ngswal("Failed !", error.message, "warning");
        }
      );
    }

  }

  dropdownlist() {
    ApiMethod.getMethod(this.modelItem.GetNTCapcityList + "/" + localStorage.aPubID + "/" + localStorage.dropId).subscribe(
      result => {

        var VendorEmailList = result.acolCapacityL;

        $('#tblVendorNTManualart tr:eq(' + localStorage.rowIdVal + ') #Capacity').val(VendorEmailList[0].ArticleCount).prop('disabled', true);
        //selectedRow.find('#Capacity').val(VendorEmailList[0].ArticleCount);
        $('#tblVendorNTManualart tr:eq(' + localStorage.rowIdVal + ') #Allocated').prop('disabled', true).val(VendorEmailList[0].Allotted);
        $('#tblVendorNTManualart tr:eq(' + localStorage.rowIdVal + ') #UnAllocated').prop('disabled', true).val(VendorEmailList[0].UnAllocated);
        $('#tblVendorNTManualart tr:eq(' + localStorage.rowIdVal + ') #Available').prop('disabled', true).val(VendorEmailList[0].Available);


      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  //ConfirmationSingle Article Send to Vendor
  sendtoVendorConfirmation() {
    if (localStorage.dropId != "") {
      ngswal("Warning", "Unable to process Vendor!,User selected!", "warning");
      return;
    }
    ngswal({
      title: "Confirmation",
      text: "Do you want to Allocate Vendor?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnSendtoVendorConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your Click cancel!", "warning");
        }
      });
  }

  //Single Article Send to Vendor
  sendtoVendor() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    var dataParam = {
      PublisherID: localStorage.aPubID,
      ArticleIDList: localStorage.aEID,
      UpdatedBy: localStorage.aLoginID
    }
    ApiMethod.postMethod(this.modelItem.SendtoVendor, dataParam).subscribe(
      result => {

        if (result.status) {
          ngswal("Success !", result.message, "success");
        } else {
          ngswal("Failed !...", result.message, "warning");
        }
        this.getFiltered();
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  //Confirmation Multiple Article Send to Vendor
  sendToVendorSelecteArticleConfirm() {
    if (localStorage.selectRowIdVal == "") {
      ngswal("Warning", "Please select article !", "warning");
      return;
    }
    ngswal({
      title: "Confirmation",
      text: "Do you want to Allocate Vendor?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    }, function (isConfirm) {
      if (isConfirm) {
        $('#sendToVendorSelecteArticleConfirm').trigger("click");
      } else {
        ngswal("Cancelled", "Your Click cancel!", "warning");
      }
    });
  }

  //Multiple Article Send to Vendor
  sendToVendorSelecteArticle() {
    if (localStorage.selectRowIdVal == "") {
      ngswal("Warning", "Please select article !", "warning");
      return;
    }
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    var dataParam = {
      PublisherID: localStorage.aPubID,
      ArticleIDList: localStorage.selectRowIdVal,
      UpdatedBy: localStorage.aLoginID
    }
    ApiMethod.postMethod(this.modelItem.SendtoVendor, dataParam).subscribe(
      result => {

        if (result.status) {
          ngswal("Success !", result.message, "success");
        } else {
          ngswal("Failed !...", result.message, "warning");
        }
        this.getFiltered();
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      }
    );
  }


  UploadPackage = (files) => {
    if (files.length === 0) {
      return false;
    }
    let fileToUpload = <File>files[0];
    let ext = fileToUpload.name.toString().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['xlsx']) == -1) {
      ngswal("Warning !", "Invalid file format upload Excel!", "warning");
      return false;
    }
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('ClientApiUrl', this.modelItem.GetUploadBatchAPI);
    formData.append('LoginId', localStorage.aLoginID);
    formData.append('PublisherId', localStorage.aPubID);
    formData.append('ProcessType', "Upload");
    $("#LoadingImagePopup").show();

    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    let http = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest() }));
    http.post($('base')[0].href + 'api/Endpoint/PostFileClient', formData).subscribe(
      (response: Response) => {

        let msgInfo = ''; let msgDetails = '';
        let result = $(response.headers);
        $.each(result, function (e, val) {
          if (val.key == 'ErrorMessage') {
            msgInfo = 'Warning';
            msgDetails = val.value.toString();
          }
          else if (val.key == 'SuccessMessage') {
            msgInfo = 'Success';
            msgDetails = val.value.toString();
          }
        });
        $('#FilePackage').val('');
        ngswal(msgInfo, msgDetails, "info");

        $("#LoadingImagePopup").hide();
      },
      (error) => {
        console.log(error.message);    // Show error, if any.
        ngswal("Warning !", error.message, "warning");
        $("#LoadingImagePopup").hide();
      }
    );
  }
  ManuallAllocationUploadExcel() {
    $("#FilePackage").trigger("click");
  }

  AutoAllocationNT() {
    ngswal({
      title: "Confirmation",
      text: "Do you want to Auto Allocate?",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Start!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    }, function (isConfirm) {
      if (isConfirm) {
        $('#btnAutoNTAllocationConfim').trigger("click");
      } else {
        ngswal("Cancelled", "Your Click cancel!", "warning");
      }
    });

  }
  AutoAllocationNTConfim() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    ApiMethod.getMethod(this.modelItem.AutoAllocation).subscribe(
      result => {
        if (result.status) {
          ngswal({
            title: "success !",
            text: result.message.toString(),
            type: "info",
            html: true
          });
        } else {
          ngswal("Failed !...", result.message, "warning");
        }
        this.getFiltered();
      }, error => {
        ngswal("Failed !", error.message, "warning");
      }
    );
  }

  //Convert String to array
  convertStringToArray(str: string): { id: number, name: string }[] {
    return str.split(',').map((s) => {
      const [name, id] = s.trim().split('|').reverse();
      return { id: parseInt(id), name };
    });
  }

}




